export const onChangeAlphaNumeric = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if(!validAccountNumber.test(e.key)){
        e.preventDefault()
    }
}

export const validAccountNumber = new RegExp('[a-zA-Z0-9]+')
